export const VIDEO_MODAL_CONFIG = {
    size: 'full' as const,
    placement: 'center' as const,
    classNames: {
        wrapper: "overflow-hidden max-h-screen",
        base: "m-0 sm:m-0 h-screen max-h-screen overflow-hidden",
        body: "overflow-hidden p-0 h-full",
        header: "border-b border-divider p-6 flex-shrink-0",
        footer: "border-t border-divider p-4 flex-shrink-0",
        closeButton: "hover:bg-default-100",
        backdrop: "bg-black/80"
    },
    scrollBehavior: 'inside' as const,
    hideCloseButton: false,
    isDismissable: true,
    motionProps: {
        variants: {
            enter: {
                opacity: 1,
                transition: {
                    duration: 0.3,
                    ease: "easeOut"
                }
            },
            exit: {
                opacity: 0,
                transition: {
                    duration: 0.2,
                    ease: "easeIn"
                }
            }
        }
    }
};

export const CONFIRMATION_MODAL_CONFIG = {
    size: 'sm' as const,
    placement: 'center' as const,
    classNames: {
        backdrop: "bg-black/50",
        base: "border border-default-200",
        header: "border-b border-default-200",
        footer: "border-t border-default-200"
    }
}; 